import { BulkResizeImage } from "../types";

export const getUnImportedImages = (images: BulkResizeImage[]) => images.filter((image) => image.state !== "imported");
